module.exports = __webpack_public_path__ + "static/media/loginbg.2ea4197c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/imgs/loginbg.jpg
// module id = 235
// module chunks = 0